import './driverTrips.css';
import DropDown from "../../../shared/drop-down/dropDown";
import TripList from "../../tripList/tripList";
import TripInfo from "../tripImfo/tripInfo";
import TripFactorDetails from "../../tripFactorDetails/tripFactorDetails";
import TripStops from "../../tripStops/tripStops";
import ReactMap from "../../../shared/map/map";
const DriverTrips = () => {
    return(
        <div className={'grid driver-trips-sec align-stretch col-2'}>
            <div className="driver-details-map">
                <div className="section-title margin-b-20">Map</div>
                <div className="driver-trips-map">
                    <ReactMap/>
                </div>
            </div>
            <div className="round-corner-8 flex align-stretch">
                <div className="trip-list-sec">
                    <div className="margin-b-10">
                        <div className="section-title margin-b-20">Trip</div>
                        <div className="font-14">
                            <DropDown list={['This Week', 'This Month', 'This Year']} selected={'This Week'}/>
                        </div>
                    </div>
                    <div className=""><TripList /></div>
                </div>
                <div className="trip-info-sec">
                    <div className="section-title margin-b-20">Details</div>
                    <div className="margin-b-20"><TripInfo/></div>
                    <div className="margin-b-20"><TripFactorDetails/></div>
                    <div className=""><TripStops/></div>
                </div>
            </div>
        </div>
    )
}

export default DriverTrips;
